export const normalizeNumber = (value) => {
  return value.replace(/[^0-9]/g, "")
}
